import { Phone, Mail, MapPin, Clock, Facebook, Hexagon } from "lucide-react";

export default function Footer({ scrollTo }) {
  return (
    <footer data-testid="footer" className="honeycomb-dark grain relative overflow-hidden bg-obsidian py-16">
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-[1.2fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <img src="/assets/hive-logo-full.png" alt="The Hive logo" className="h-12 w-12 rounded-xl bg-white object-contain p-0.5 ring-1 ring-amber-500/40" />
              <span className="font-script text-3xl text-[#F9F6EF]">The Hive</span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-neutral-400" data-testid="footer-tagline">
              Connecting individuals &amp; families to services, support &amp; resources
              right here in our community.
            </p>
            <p className="mt-5 font-script text-2xl text-amber-400" data-testid="footer-quote">
              "Be the hands + feet of Jesus."
            </p>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-amber-500">Contact</p>
            <ul className="mt-5 space-y-4 text-sm text-neutral-300">
              <li>
                <a href="tel:4794375939" data-testid="footer-call-link" className="flex items-center gap-3 transition-colors duration-300 hover:text-amber-400">
                  <Phone size={16} className="text-amber-500" /> 479-437-5939
                </a>
              </li>
              <li>
                <a href="mailto:Themadcohive@gmail.com" data-testid="footer-email-link" className="flex items-center gap-3 transition-colors duration-300 hover:text-amber-400">
                  <Mail size={16} className="text-amber-500" /> Themadcohive@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 shrink-0 text-amber-500" />
                <span data-testid="footer-address">701 Phillips Place, Suite 5<br />Huntsville, AR</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={16} className="mt-0.5 shrink-0 text-amber-500" />
                <span data-testid="footer-hours">Mon – Fri, 9:00 AM – 2:00 PM</span>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-amber-500">Follow &amp; Explore</p>
            <ul className="mt-5 space-y-4 text-sm text-neutral-300">
              <li>
                <a
                  href="https://www.facebook.com/share/1CE1uxViXo/"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-facebook-link"
                  className="flex items-center gap-3 transition-colors duration-300 hover:text-amber-400"
                >
                  <Facebook size={16} className="text-amber-500" /> The Hive on Facebook
                </a>
              </li>
              {[
                ["About", "#about"],
                ["Services", "#services"],
                ["How It Works", "#how-it-works"],
                ["Get Involved", "#ways-to-help"],
                ["Visit Us", "#contact"],
              ].map(([label, target]) => (
                <li key={target}>
                  <button
                    onClick={() => scrollTo(target)}
                    data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="flex items-center gap-3 transition-colors duration-300 hover:text-amber-400"
                  >
                    <Hexagon size={12} className="text-amber-500/70" /> {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-amber-500/15 pt-8 sm:flex-row">
          <p className="text-xs text-neutral-500" data-testid="footer-copyright">
            © {new Date().getFullYear()} The Hive · Huntsville, Arkansas · Made with love in Madison County
          </p>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-amber-500/70" data-testid="footer-motto">
            Encourage · Serve · Grow · Thrive
          </p>
        </div>

        <div className="mt-6 flex justify-center">
          <a
            href="https://tybra.digital"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-credit-link"
            className="text-[11px] tracking-wide text-neutral-600 transition-colors duration-300 hover:text-amber-500/80"
          >
            Powered by{" "}
            <span className="underline decoration-amber-500/50 underline-offset-2">Tybra Digital</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
